module.exports = __webpack_public_path__ + "img/finish.bb881561.png";